import React, { createContext, useContext, useState } from "react";

const OkrDataContext = createContext({
  normalizedOkrData: null,
  setNormalizedOkrData: () => {},
  kpiOwnersList: [],
  setKpiOwnersList: () => {},
  kpiOwnersExcludedWithoutScorecardCount: 0,
  setKpiOwnersExcludedWithoutScorecardCount: () => {},
  selectedKpiOwnerForChat: null,
  setSelectedKpiOwnerForChat: () => {},
  selectedKpiOwnersForCompare: [],
  setSelectedKpiOwnersForCompare: () => {},
});

export const OkrDataProvider = ({ children }) => {
  const [normalizedOkrData, setNormalizedOkrData] = useState(null);
  const [kpiOwnersList, setKpiOwnersList] = useState([]);
  const [kpiOwnersExcludedWithoutScorecardCount, setKpiOwnersExcludedWithoutScorecardCount] =
    useState(0);
  const [selectedKpiOwnerForChat, setSelectedKpiOwnerForChat] = useState(null);
  const [selectedKpiOwnersForCompare, setSelectedKpiOwnersForCompare] = useState([]);

  return (
    <OkrDataContext.Provider
      value={{
        normalizedOkrData,
        setNormalizedOkrData,
        kpiOwnersList,
        setKpiOwnersList,
        kpiOwnersExcludedWithoutScorecardCount,
        setKpiOwnersExcludedWithoutScorecardCount,
        selectedKpiOwnerForChat,
        setSelectedKpiOwnerForChat,
        selectedKpiOwnersForCompare,
        setSelectedKpiOwnersForCompare,
      }}
    >
      {children}
    </OkrDataContext.Provider>
  );
};

export const useOkrData = () => useContext(OkrDataContext);

export default OkrDataContext;
